<template>
	<div class="clyy">
        <main>
            <div class="list">
                <h2 style="text-align:center">车辆用油</h2>

                <van-field
                    v-model="chepai"
                    center
                    label="车牌"
                    placeholder="请输入车牌"
                >
                    <template #button>
                        <van-button size="mini" type="danger" @click="searchCar()">搜索</van-button>
                    </template>
                </van-field>

                <van-field label="部门" v-model="bumen" readonly />
                <van-field label="车辆类型" v-model="chepai_1" readonly />
                <van-field label="车辆状态" v-model="xz_status" readonly />
                
                <van-field label="所属公司" v-model="chepai_2" readonly />
                <van-field label="使用公司" v-model="chepai_3" type="textarea" readonly autosize/>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="gongsi2"
                    label="加油油罐"
                    placeholder="点击选择油罐"
                    @click="showPicker1 = true" 
                />

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="加油时间"
                    placeholder="点击选择加油时间"
                    @click="showPicker3 = true"
                />

                <van-popup v-model:show="showPicker1" position="bottom">
                    <van-picker 
                        show-toolbar 
                        :columns="columns1" 
                        @confirm="onConfirm1"
                        @cancel="showPicker1 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker4" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns4"
                        @confirm="onConfirm4"
                        @cancel="showPicker4 = false"
                    />
                </van-popup>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="fangshi"
                    label="加油方式"
                    placeholder="点击选择加油方式"
                    @click="showPicker4 = true"
                />

                <van-field label="加油金额" v-model="money" v-if="show_money" type="number" />
                <van-field label="卡号" v-model="yk_num" v-if="show_money"  readonly/>
                <van-field label="余额" v-model="yk_yue" v-if="show_money"  readonly/>

                <van-field label="驾驶员" v-model="name" />
                <van-field label="开始里程" v-model="start1" />
                <van-field label="结束里程" v-model="start2" type="number" />
                <van-field label="行驶里程" v-model="start3" readonly />
                <van-field label="加油升数" v-model="shengshu" type="number" />
                <van-field label="单价" v-model="d_price" type="number" />
                <van-field label="标准油耗" v-model="youhao" readonly/>
                <van-field label="实际油耗" v-model="youhao2"  readonly/>
                <van-field label="备注" v-model="mess" />

                <div style="margin-left:16px">
                    <h4>开始里程，结束里程，加油升数金额，整车(带车牌)</h4>
                    <van-uploader  v-model="fileList" multiple :max-count="4"  :before-read="beforeRead"/>
                </div>

                <van-button type="danger" style="width:100%;margin-top:40px" :disabled="disabled" @click="sub()">提交</van-button>

            </div>
        </main>
    </div>
</template>

<script>
    import { url2,carList,ykList } from '../router/api';
    import option from "../config/option.js"

	export default{
		data(){
			return{
                showPicker1:false,
                showPicker2:false,
                showPicker3:false,
                showPicker4:false,
                disabled:false,
                columns1:[],
                columns2:[],
                columns4:[],
                currentDate: new Date(),
                gongsi2:'',
                chepai:'',
                chepai_1:'',
                chepai_2:'',
                chepai_3:'',
                bumen:'',

                time:'',
                name:'',
                start1:'',
                start2:'',
                start3:'',
                shengshu:'',
                youhao:'',
                youhao2:'',
                mess:'',
                fangshi:'',
                money:'',
                yk_num:'',
                yk_yue:'',
                fileList:[],

                total: 1,
                per_page: 50,
                current_page: 1,
                show_money:false,
                readonly:false,
                maxDate: new Date(),

                d_price:'',
                xz_status:'',

                kslc_time:[] //开始里程时间
            }
        },

        watch: {
            start1(val) {
                this.start3 = this.start2 - this.start1;
                this.start3 = this.start3.toFixed('2')
            },
            start2(val) {
                this.start3 = this.start2 - this.start1;
                this.start3 = this.start3.toFixed('2')
            },
            shengshu(val) {
                this.youhao2 = this.shengshu / this.start3 * 100;
                this.youhao2 = this.youhao2.toFixed('2')
                this.d_price = this.money / this.shengshu
                this.d_price = this.d_price.toFixed('2')
            },
            start3(val) {
                this.youhao2 = this.shengshu / this.start3 * 100;
                this.youhao2 = this.youhao2.toFixed('2')
            },
            money(val) {
                this.d_price = this.money / this.shengshu
                this.d_price = this.d_price.toFixed('2')
            },
        },

        mounted() {
            const elementToRemove = '全部';
            this.columns1 = option.you.filter(item => item !== elementToRemove);

            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            time1 =  this.GetPreMonthDay(time1,4)
            var time2 = Y + M +D
            this.kslc_time.push(time1)
            this.kslc_time.push(time2)
        },

		methods: {
            GetPreMonthDay(date, monthNum) {
                var dateArr = date.split('-');
                var year = dateArr[0]; //获取当前日期的年份
                var month = dateArr[1]; //获取当前日期的月份
                var day = dateArr[2]; //获取当前日期的日
                var days = new Date(year, month, 0);
                days = days.getDate(); //获取当前日期中月的天数
                var year2 = year;
                var month2 = parseInt(month) - monthNum;
                if (month2 <= 0) {
                    var absM = Math.abs(month2);
                    year2 = parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
                    month2 = 12 - (absM % 12);
                }
                var day2 = day;
                var days2 = new Date(year2, month2, 0);
                days2 = days2.getDate();
                if (day2 > days2) {
                    day2 = days2;
                }
                if (month2 < 10) {
                    month2 = '0' + month2;
                }
                var t2 = year2 + '-' + month2 + '-' + day2;
                return t2
            },

            sub() {
                if(this.xz_status != '在用') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '车辆状态不对',
                    }).then(() => {
                        return;
                    });
                } else if(this.chepai==''||this.chepai_1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写正确车牌',
                    }).then(() => {
                        return;
                    });
                } else if(this.gongsi2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择加油油罐',
                    }).then(() => {
                        return;
                    });
                } else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择加油时间',
                    }).then(() => {
                        return;
                    });
                } else if(this.fangshi=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择加油方式',
                    }).then(() => {
                        return;
                    });
                } else if(this.fangshi!='油罐加油'&&this.money=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写金额',
                    }).then(() => {
                        return;
                    });
                }else if(this.name=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写驾驶员',
                    }).then(() => {
                        return;
                    });
                }  else if(this.start1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写开始里程',
                    }).then(() => {
                        return;
                    });
                }  else if(this.start2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写结束里程',
                    }).then(() => {
                        return;
                    });
                } else if(Number(this.start1)>=Number(this.start2)) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '结束里程要大于开始里程',
                    }).then(() => {
                        return;
                    });
                } else if(Number((this.start2)-Number(this.start1)<10)) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '行驶里程过小',
                    }).then(() => {
                        return;
                    });
                } else if(Number((this.start2)-Number(this.start1)>10000)) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '行驶里程过大',
                    }).then(() => {
                        return;
                    });
                } else if(this.shengshu=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写加油升数',
                    }).then(() => {
                        return;
                    });
                } else if(this.youhao=='' || this.youhao==0) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写油耗',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList.length<2) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请最少上传两张照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                    this.axios.post(url2+'upload4',(formData),{
                        headers: {  'Content-Type': 'multipart/form-data;' }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.sure2(res.data.data)
                        }  else {
                            this.loading.close();
                        }
                    }).catch(err=> {
                        this.loading.close();
                        console.log(err);
                    });
                }
            },

            sure2(photo) {
                this.axios.get(url2+'youka', {
                    params:{
                        chepai:this.chepai,
                        bumen:this.bumen,
                        chepai_1:this.chepai_1,
                        chepai_2:this.chepai_2,
                        chepai_3:this.chepai_3,
                        gongsi2:this.gongsi2,
                        time:this.time,
                        fangshi:this.fangshi,
                        money:this.money,
                        name:this.name,
                        start1:this.start1,
                        start2:this.start2,
                        start3:this.start3,
                        shengshu:this.shengshu,
                        youhao:this.youhao,
                        youhao2:this.youhao2,
                        mess:this.mess,
                        url:photo.toString(),

                        num:this.yk_num,
                        yue:this.yk_yue,
                        d_price:this.d_price,
                        xz_status:this.xz_status,
                    }
                }).then(res=> {
                    if(res.data.code==1) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.disabled = true
                        });
                    } else {
                        this.$dialog.alert({
                            title: '提示',
                            message: '失败',
                        }).then(() => {
                            this.loading.close();
                            this.disabled = false
                        });
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },

            searchCar() {
                carList({
                    id:'',
                    chepai:this.chepai ? this.chepai: '',
                    xz_status:'',
                    gongsi: '' ,
                }).then(res=> {
                    if(res.code==1) {
                        res.data.map(item=>{
                            item.text = item.chepai
                            delete (item.chepai)
                        })
                        this.columns2 = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
                this.showPicker2 = true
            },

            searchCar2() {
                var time1 = ''
                var time2 = ''
                if(this.kslc_time) {
                    time1 = this.kslc_time[0] + ' 00:00:00'
                    time2 = this.kslc_time[1] + ' 23:59:59'
                }
                this.axios.get(url2+'youkaSearch', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        chepai:this.chepai,
                        address:'',
                        gongsi:'',
                        name:'',
                        bumen:'',
                        crate_time1: time1,
                        crate_time2: time2,
                        status:'',
                        status2:1,
                        fangshi:'',
                        xz_status:'',
                    }
                }).then(res=> {
                    if(res.data.data.data[0]) {
                        this.start1 = res.data.data.data[0].start2
                        this.readonly = true
                    } else {
                        this.start1 = ''
                        this.readonly = false
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            onConfirm1(value) {
                this.gongsi2 = value
                if(this.gongsi2!='场外加油站') {
                    this.columns4 = ['油罐加油']
                    this.fangshi = '油罐加油'
                    this.show_money = false
                } else {
                    this.columns4 = ['油卡加油','现金加油']
                    this.fangshi = '油卡加油'
                    this.show_money = true
                }
                this.showPicker1 = false;
            },
            async onConfirm2(value) {
                this.chepai = value.text
                this.chepai_1 = value.type
                this.chepai_2 = value.shu_org
                this.chepai_3 = value.yong_org
                this.youhao = value.youhao
                this.bumen = value.bumen
                this.xz_status = value.xz_status
                this.searchCar2()
                this.showPicker2 = false;

                ykList({
                    id:'',
                    org:value.yong_org,
                    chepai:value.text,
                    zfk:'',
                }).then(res=> {
                    if(res.code==1) {
                        if(res.data.length>0) {
                            this.yk_num = res.data[0].num
                            this.yk_yue = res.data[0].money
                        }
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },
            onConfirm3(value) {
                this.time = this.formatDate(value)
                this.showPicker3 = false;
            },
            onConfirm4(value) {
                this.fangshi = value
                this.showPicker4 = false;
            },

             formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },
            beforeRead(file){
                return this.$compress(file)
            },
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .clyy main {
        font-size: 14px;
        padding: 40px 16px;
        background-color: #FFDCA3;
    }
    .clyy .list {
        background-color: #fff;
        padding: 20px 20px 80px 20px;
    }
</style>

